import { DataBean } from "../../DataBean";


export class SpreadSheetForRetroactive extends DataBean {

    public async setSocialSecuritySpreadSheetForRetroactive(idSocialSecuritySpreadSheet: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "boolean_setSocialSecuritySpreadSheetForRetroactive_Number", [idSocialSecuritySpreadSheet]);
    }

}